import { render, staticRenderFns } from "./ReviewRequestNew.vue?vue&type=template&id=1a8da409&scoped=true&"
import script from "./ReviewRequestNew.vue?vue&type=script&lang=js&"
export * from "./ReviewRequestNew.vue?vue&type=script&lang=js&"
import style0 from "./ReviewRequestNew.vue?vue&type=style&index=0&id=1a8da409&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8da409",
  null
  
)

export default component.exports